import React from 'react';
import { Box, Typography } from '@mui/material';
import { BiMobileAlt } from 'react-icons/bi';

const APP_STORE_URL = 'https://apps.apple.com/us/app/hopdrive/id6473622492';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.hopdrive.driver&pcampaignid=web_share';

interface AppDownloadBadgesProps {
  /** Optional label above the badges */
  label?: string;
  /** Compact mode — inline badges without icon/messaging */
  compact?: boolean;
}

/**
 * Displays HopDrive mobile app download badges (App Store + Google Play).
 * Use compact mode for inline placement, full mode for empty states.
 */
const AppDownloadBadges: React.FC<AppDownloadBadgesProps> = ({
  label,
  compact = false,
}) => {
  if (compact) {
    return (
      <Box>
        {label && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
            {label}
          </Typography>
        )}
        <Box sx={{ display: 'flex', gap: 1 }}>
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            <img src="/badges/app-store.svg" alt="Download on the App Store" height={32} />
          </a>
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
            <img src="/badges/google-play.svg" alt="Get it on Google Play" height={32} />
          </a>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4, px: 3 }}>
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          bgcolor: 'grey.100',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <BiMobileAlt size={36} color="#9ca3af" />
      </Box>

      {label && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center', maxWidth: 360 }}>
          {label}
        </Typography>
      )}

      <Box sx={{ display: 'flex', gap: 1.5 }}>
        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img src="/badges/app-store.svg" alt="Download on the App Store" height={40} />
        </a>
        <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img src="/badges/google-play.svg" alt="Get it on Google Play" height={40} />
        </a>
      </Box>
    </Box>
  );
};

export default AppDownloadBadges;
